"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ECPoDateEventActions = exports.EventTypes = void 0;
var EventTypes;
(function (EventTypes) {
    EventTypes["ECPoDateEvent"] = "ECPoDateEvent";
})(EventTypes = exports.EventTypes || (exports.EventTypes = {}));
var ECPoDateEventActions;
(function (ECPoDateEventActions) {
    ECPoDateEventActions["ECPoDateCreated"] = "ECPoDateCreated";
    ECPoDateEventActions["ECPoDateUpdated"] = "ECPoDateUpdated";
    ECPoDateEventActions["ECPoDateDeleted"] = "ECPoDateDeleted";
    ECPoDateEventActions["ECCreatePoDate"] = "CreateECPoDate";
    ECPoDateEventActions["ECUpdatePoDate"] = "UpdateECPoDate";
    ECPoDateEventActions["ECDeletePoDate"] = "DeleteECPoDate";
})(ECPoDateEventActions = exports.ECPoDateEventActions || (exports.ECPoDateEventActions = {}));
